import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class CanonicalService {

  constructor(
    @Inject(DOCUMENT) private doc: Document,
    private router: Router,
  ) {}

  setCanonicalURL(url?: string) {
    const canURL = url === undefined ? this.doc.URL : url;
    const link: HTMLLinkElement = this.doc.createElement('link');
    const head: HTMLElement|null = this.doc.querySelector('head');
    if (head) {
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canURL);
      head.appendChild(link);

      this.updateCanonicalURL();
    }
  }

  updateCanonicalURL() {
    let url: string;

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    )
      .subscribe(() => {
        if (this.doc.URL.indexOf('#') !== -1) {
          url = this.doc.URL.slice(0, this.doc.URL.lastIndexOf('#'));
        } else {
          url = this.doc.URL;
        }

        const canonicalLinkElement: HTMLElement|null = this.doc.querySelector('link[rel="canonical"]');
        if (canonicalLinkElement) {
          canonicalLinkElement.setAttribute('href', url);
        }
      });
  }
}
